export const Sports = [
  { id: 1, text: 'Volleyball', showSurfaces: true },
  { id: 5, text: 'Tennis', showSurfaces: true },
  { id: 2, text: 'Pickleball', showSurfaces: false },
  { id: 3, text: 'Cornhole', showSurfaces: false },
  { id: 4, text: 'Roundnet', showSurfaces: true },
  { id: 6, text: 'TeqVoly', showSurfaces: true },
  { id: 7, text: 'TeqBall', showSurfaces: true }
]
